/* eslint-disable @typescript-eslint/no-explicit-any */
import { useTranslation } from 'react-i18next'
import { BsFillShareFill } from 'react-icons/bs'
import { Link, useNavigate } from 'react-router-dom'
import { animated, useTransition } from 'react-spring'
import { UserMenu } from '../UserMenu'
import { useEffect, useRef, useState } from 'react'
import { RootState } from '../../store'
import { useSelector } from 'react-redux'
import socialMedia from '../../assets/img/social-media.png'

export const HeaderMobile = () => {
  const {
    user: { data: user },
  } = useSelector((state: RootState) => state.userReducer)
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dropdownRef = useRef<HTMLDivElement>(null)
  const buttonRef = useRef<HTMLButtonElement>(null) // Create a ref for open user menu button
  const [showDropdown, setShowDropdown] = useState(false)
  const [copied, setCopied] = useState(false)
  const transitions = useTransition(showDropdown, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 250 },
  })
  

  const copylink = (username: string) => {
    setCopied(true)
    const link = `https://waslat.app/${username}`
    navigator.clipboard.writeText(link)
    setTimeout(() => {
      setCopied(false)
    }, 1000)
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent): void => {
      if (
        dropdownRef.current &&
        buttonRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        !buttonRef?.current?.contains(event.target as Node)
      ) {
        closeMenu()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef, buttonRef])

  const closeMenu = () => {
    setShowDropdown(false)
  }

  return (
    <div className="flex items-center justify-between border-b border-gray-300 px-5 py-4">
      <Link className="text-base text-secondary" to="/links">
        {t('links')}
      </Link>
      <div className="flex gap-5">
        {/* <Button
          text={t('tryProFree')}
          type="button"
          className="px-2 text-sm text-white sm:w-40"
          onClick={() => navigate('/pricing')}
        /> */}
        <button
          type="submit"
          ref={buttonRef}
          className="flex h-[40px] cursor-pointer items-center justify-center gap-2 rounded-lg border border-blue-500 px-2 text-sm font-medium text-[#407BFF] shadow-md focus:outline-none sm:w-32"
          onClick={() => setShowDropdown((prevState) => !prevState)}
        >
          <BsFillShareFill color="#407BFF" />

          {t('Share')}
        </button>
        {transitions((styles: any, item: any) =>
          item ? (
            <animated.div
              style={styles}
              ref={dropdownRef}
              className=" absolute right-5 top-16 z-10 w-[320px] rounded-lg border border-gray-300 bg-white px-2.5 py-3 shadow-md"
            >
              <h5 className="text-md py-2 text-center font-bold">
                {t('shareTitle')}
              </h5>
              <p className="text-sm">{t('shareWaslat')}</p>
              <img src={socialMedia} alt="social media" className="w-full" />
              <div className="bottom-1 my-2 flex w-full cursor-pointer justify-between rounded-md p-3 shadow-md" onClick={() => copylink(user?.username)}>
                <span>https://waslat.app/{user?.username}</span>
                {copied ? <span className='text-blue-500'>{t('Copied')}</span> : <span>{t('Copy')}</span>}
              </div>
            </animated.div>
          ) : null,
        )}
        <UserMenu />
      </div>
    </div>
  )
}
